import React from "react";
import CurrentPlanComp from "../../../components/usermembership/currentplancomp";
import UserProfileLayout from "../../../components/layout/userprofilelayout/userprofilelayout";

export default function CurrentPlan() {
    return (
        <>
            <UserProfileLayout>
                <CurrentPlanComp />
            </UserProfileLayout>
        </>
    )
}